import GenreMovies from './GenreMovies';

export default GenreMovies;
